import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
`;

export const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;

  .home-greetings {
    font-size: 1.7rem;
    line-height: 2.2rem;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.primary};

    span {
      color: ${({ theme }) => theme.colors.text};
      font-weight: normal;
    }
  }

  .home-content-carousel {
    margin: 26px 0;
  }
`;
